import cx from 'classnames';
import Box, { BoxStyleProps } from '../Box';
import Container from '../Container';
import Logo from '../Logo';

import { ReactComponent as BookSvg } from '@frontend/icons/book.svg';
import { ReactComponent as CommentSvg } from '@frontend/icons/comment-2-question.svg';

import styles from './Footer.module.css';
import Button from '../Button/Button';
import Icon from '../Icon/Icon';

interface FooterProps extends BoxStyleProps {
  className?: string;
}

export default function Footer({
  className,
  ...otherProps
}: FooterProps): JSX.Element {
  return (
    <Box as="footer" className={cx(styles['base'], className)} {...otherProps}>
      <Container>
        <div className={styles['inner']}>
          <Logo />
          <nav className={styles['navigation']}>
            <Button
              as="a"
              href="https://support.xmoney.com/en/"
              target="_blank"
              rel="noopener noreferrer"
              size="medium"
              leftIcon={<Icon component={<CommentSvg />} />}
            >
              Help Center
            </Button>
            <Button
              as="a"
              href="https://xmoney.com/legal-acknowledgement"
              target="_blank"
              rel="noopener noreferrer"
              size="medium"
              leftIcon={<Icon component={<BookSvg />} />}
            >
              Our Policies
            </Button>
          </nav>
        </div>
      </Container>
    </Box>
  );
}
